<!-- 能源概况 -->
<template>
    <div class='container'>

        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <el-page-header style="height:40px;line-height:40px;" @back="goBack" :content="pumps_name + '节能明细'"></el-page-header>
            </div>
            <div class="energy-box">
                <ul class="situation-list">
                    <li class="situation-flex">
                        <span>改造前：{{before_power}} kWh</span>
                        <span>改造后：{{after_power}} kWh</span>
                        <span>节能基数：{{deference_power}} kWh</span>
                    </li>
                    <li class="situation-flex">
                        <span>节约用量：{{energy_conservation_use}} kWh</span>
                        <span>运行时长：{{running_time}} h</span>
                        <span></span>
                    </li>
                    <li class="situation-flex">
                        <span>节约电费：{{energy_conservation_fee}} 元</span>
                        <span>电价：{{electricity_rate}} 元</span>
                        <span>总电费：{{energy_conservation_sum}} 元</span>
                    </li>
                </ul>
            </div>
        
        <div style="height:20px;"></div>

        <div class="charts-box">
            <div id="charts"  style="width: 100%;height:100%;"></div>
            <div class="nodata" v-show="energy_conservation.length===0">
                --  暂无数据 --
            </div>
        </div>
        </el-card>
    </div>
</template>

<script>
import Service from '@/api/Service'
import echarts from "echarts"
import { FormatDate, FormatDateDay } from '@/utils/utils.js'
var chart1 = null
const mGetDate = function(){
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let d = new Date(year, month, 0);
    return d.getDate();
}

export default {
    name:  'energypumpdetail',
    data() {
        return {
            index: 0,
            pumpList: [],
            pumps_name: '',

            energy_conservation: [], 
            energy_pump: [],  

            before_power: 0,
            after_power: 0,
            deference_power: 0,
            running_time: 0,
            electricity_rate: 0,
            energy_conservation_use: 0,
            energy_conservation_fee: 0,
            energy_conservation_sum: 0,
        };
    },

    components: {},

    computed: {
        
    },

    mounted() {
        this.$nextTick(()=>{

            // 基于准备好的dom，初始化echarts实例
            chart1 = echarts.init(document.getElementById('charts'));
             let time = FormatDate('yyyy-MM-dd')
            this.getData(time)
            this.getPumpList();
        })
        
    },

    created() {
        this.index = this.$route.params.id;
    },

    methods: {
        async getPumpList() {
            let day =  new Date().getDate()
            let time_range = 'day'
			let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            let res = await Service.getPumpsConservationByPIDMonthRange({day, time_range,time})
            if(res) {
                this.electricity_rate = res.electricity_rate || []
                let list = res.pumps_detail.map(v=>{
                    return {
                        pumps_name: v.pumps_name,
                        before_power: v.before_power,
                        after_power: v.after_power,
                        deference_power: v.deference_power,
                        running_time: v.running_time.value,
                        energy_conservation: v.energy_conservation,
                        energy_conservation_fee:v.energy_conservation_fee.toFixed(2),
                        pumps_divided_proportion: res.pumps_divided_proportion,
                        pumps_divided_proportion_fee: v.pumps_divided_proportion_fee.toFixed(2),
                        pumps_energy_conservation_id: v.pumps_energy_conservation_id,
                        electricity: v.electricity
                    }
                })
                this.pumpList = list
                let pumpInfo = list.filter(v=>{ return v.pumps_energy_conservation_id == this.index})[0]
                this.pumps_name = pumpInfo.pumps_name
                this.after_power = pumpInfo.after_power
                this.before_power = pumpInfo.before_power
                this.deference_power = pumpInfo.deference_power
                this.energy_conservation_use = pumpInfo.energy_conservation
                this.energy_conservation_fee = pumpInfo.energy_conservation_fee
                this.energy_conservation_sum = pumpInfo.electricity.toFixed(2)
                this.running_time = pumpInfo.running_time
            }
        },
        async getData(time) {
            time = time + ' 23:59:59'
            let day = new Date().getDate()
            let time_range = 'day'
            let res = await Service.getPumpStatisticByPIDTimeRange({day, time_range, time})
            if(res) {
                let pump = res.pump_datail.filter(v=>{ return v.pumps_energy_conservation_id == this.index})[0]
              
                this.energy_conservation = pump.electricity_fee.conservation_electricity_fee.map(v=>{return v.value.toFixed(2)})
                this.energy_pump = pump.electricity_fee.sum_electricity_fee.map(v=>{return v.value.toFixed(2)})
                this.initData()
            }
        },
        initData() {
            this.initChart1(this.energy_conservation, this.energy_pump)
        },
        initChart1(nowDay, otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                        
                    },
                    data: otherDay,
                },
            ]
            chart1.setOption(option);
        },
        getOption() {
            let Len = mGetDate();
            let Axis = []
            for (let index = 0; index < Len; index++) {
                Axis.push(index+1 + '日')
            }
            
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总节约电费', '总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 70,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: Axis
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总节约电费',
                        type: 'bar',
                        stack: '电费',
                        data: [],
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                    },
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: [],
                    },
                ],
            }
        },
        goBack() {
            this.$router.go(-1);//返回上一层
        }
    }
}

</script>
<style lang='less' scoped>
.charts-box{
    width: 80%;
    height: 300px;
    margin: 0 auto 0;
    #charts{
        width: 100%;
        height: 100%;
    }
}
.situation-list{
        margin: 10px;
        .situation-flex{
            display: flex;
            flex-direction: row;
            span{
                flex: 1;
                text-align: left;
                font-size: 14px;
                color: #666;
                line-height: 40px;
                margin: 5px 0;
                text-align: left;
                padding: 0 20px;
            }
        }
    }
</style>